<script setup lang="ts">
import { FIELD_INNER_STYLES } from '@autobid/ui/constants/FIELD_INNER_STYLES'
</script>

<template>
  <div :class="FIELD_INNER_STYLES">
    <slot />
  </div>
</template>
